import './PageSelectItem.pcss';
import React from 'react';
import { includes } from 'lodash';
import moment from 'moment/moment';
import classnames from 'classnames';
import { PlanBadge } from '../../../../../../common/components/ProBadge';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { CheckIcon } from '../../../../../../common/component-icons/CheckIcon/CheckIcon';

type Props = {
  page: EnhancedBillingPage;
  onClick: (page: EnhancedBillingPage) => void;
  selectedPages: number[];
  metMaximumPages: boolean;
  forceSelection: boolean;
};

export const PageSelectItem = (props: Props) => {
  const { page, onClick, selectedPages, metMaximumPages, forceSelection } =
    props;
  const isSelected = includes(selectedPages, page.id);
  const disabled = (metMaximumPages && !isSelected) || forceSelection;

  const classList = classnames('page-select-item', {
    'page-select-item--selected': isSelected,
    'page-select-item--disabled': disabled,
  });

  const checkColor = isSelected ? '#fff' : '#28ccb3';

  const clickHandler = () => {
    if (disabled) return;
    onClick(page);
  };

  return (
    <div className={classList} onClick={clickHandler}>
      <div className="page-select-item__left-section">
        <img
          src={page.squarePicture}
          className="page-select-item__image"
          alt="Facebook page icon"
        />

        <div className="page-select-item__meta-wrapper">
          <div className="page-select-item__meta-top">
            <div className="page-select-item__name-wrapper">{page.name}</div>

            <PlanBadge billingType={page.pageBillingType} />
          </div>

          <div className="page-select-item__connected-since">
            Connected Since: {moment(page.createdAt).format('MM/DD/YYYY')}
          </div>
          <a
            className="facebook-page-card__facebook-link"
            href={`https://facebook.com/${page.remoteId}`}
            target="_blank"
          >
            Facebook Page Id: {page.remoteId}
          </a>
        </div>
      </div>

      <div className="page-select-item__circle">
        <CheckIcon color={checkColor} />
      </div>
    </div>
  );
};
